// extracted by mini-css-extract-plugin
module.exports = {"post":"styles_post__o8irJ flex items-center justify-center","image":"styles_image__1a5xI"};